import {AuditableResult} from './auditable-result';
import {BrokenRule} from './broken-rule';
import {IataImport} from "./iata-import";

export class AuditableIataImport extends AuditableResult<IataImport> {
  constructor(iataImport: IataImport, brokenRules: Array<BrokenRule> = new Array<BrokenRule>()) {
    super(iataImport, brokenRules);
  }

  static parseIataImportResponse(json: Object) {
    var success = json["wasSuccessful"];
    let iataImport: IataImport = new IataImport(json["success"], json["failures"], json["skipped"]);
    let brokenRules;

    if (!success) {
      brokenRules = json["brokenRules"].map(r => Object.assign(new BrokenRule(), {
        message: r.message
      }));
    }

    return new AuditableIataImport(iataImport, brokenRules);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/auditable-iata-import.ts